// action types
export const _SUCCESS = "_SUCCESS";
export const _REQUEST = "_REQUEST";
export const _FAILURE = "_FAILURE";
export const _INIT = "_INIT";

// statuses
export const INIT = "INIT";
export const OK = "OK";
export const LOADING = "LOADING";
export const ERROR = "ERROR";
export const ANONYMOUS = "ANONYMOUS";
export const AUTHENTICATED = "AUTHENTICATED";

// local storage keys
export const ACCESS_TOKEN_KEY = "access_token";
export const REFRESH_TOKEN_KEY = "refresh_token";
